import { Component, OnInit, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { TechnicianService } from '../../../services/technician.service';

@Component({
  selector: 'app-technician-picker',
  templateUrl: './technician-picker.component.html',
  styleUrls: ['./technician-picker.component.scss']
})
export class TechnicianPickerComponent implements OnInit {
  @Output() onTechnicianSet = new EventEmitter<any>();
  @Input() _placeholder: string = 'Please Select';
  @Input() technicianId: number;
  @Input() getAll: boolean = false;
  technicians = [];

  constructor(private technicianService: TechnicianService) {
  }

  ngOnInit(): void {

    if (this.getAll) {
      this.technicianService.getAll().then((technicians) => {
        this.technicians = technicians;

        if (this.technicianId != null)
          this.technicianChanged(this.technicianId);
      });
   } else {
     this.technicianService.getActive().then((technicians) => {
       this.technicians = technicians;

       if (this.technicianId != null)
         this.technicianChanged(this.technicianId);
     });
    }
  
  }

    ngOnChanges(changes: SimpleChanges): void {
      if ((changes.technicianId != null && changes.technicianId.currentValue != null)) {
      
        if ((this.technicianId != undefined && this.technicianId != undefined)&&(this.technicians != undefined && this.technicians != undefined)) {
          var location = this.technicians.find(a => a.id == this.technicianId);
          this._placeholder = location.name;
  
        }
      
      }
    }

  technicianChanged(technicianId) {
    //console.log(technicianId);
    this.onTechnicianSet.emit(technicianId);
  }

}
